/* src/app/components/payroll/timesheets/timesheet-payroll-processing/timesheet-payroll-run-results/timesheet-payroll-run-results.component.css */
.table-style {
  width: 100%;
}
.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.comment-section {
  margin-top: 12px;
}
.dialog-textarea {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.required-marker {
  color: #ff4d4f;
}
/*# sourceMappingURL=timesheet-payroll-run-results.component-XUTL2VT3.css.map */
